import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import { Col, Row } from "react-bootstrap";
import { FormattedMessage } from "react-intl";
import ImageUploader from "./ImageUploader";

const SliderItem = ({
  slider,
  setSliders,
  index,
  removeSlider,
  handleInputOnChange,
  removeImg,
  countries,
  countriesLoading,
}) => {
  // eslint-disable-next-line no-unused-vars
  const [selectedBackgroundImage, setSelectedBackgroundImage] = useState("");
  const [selectedTitleImage, setSelectedTitleImage] = useState("");

  useEffect(() => {
    if (slider) {
      setSelectedBackgroundImage({ path: slider?.backgroundImage });
      setSelectedTitleImage({ path: slider?.image });
    }
  }, [slider]);

  return (
    <Row key={index}>
      <div className="add-multi-component">
        <Row style={{ rowGap: "10px" }}>
          <button
            type="button"
            onClick={() => removeSlider(index)}
            className="removeImg"
            aria-label="Remove"
          >
            <img src={removeImg} alt="" />
          </button>

          <Row>
            <Row>
              {/* <Col lg={12} xs={12}>
                                <div className="form-group required">
                                    <h5>
                                        <FormattedMessage
                                            id={
                                                "backgroundImage"
                                            }
                                        />
                                    </h5>
                                    <ImageUploader
                                        selectedImage={selectedBackgroundImage}
                                        setSelectedImage={setSelectedBackgroundImage}
                                        slider={slider}
                                        index={index}
                                        setSliders={setSliders}
                                        name={"backgroundImage"}
                                    />
                                </div>
                            </Col> */}
              <Col lg={12} xs={12}>
                <div className="form-group required">
                  <h5>
                    <FormattedMessage id={"image"} />
                  </h5>
                  <ImageUploader
                    selectedImage={selectedTitleImage}
                    setSelectedImage={setSelectedTitleImage}
                    slider={slider}
                    index={index}
                    setSliders={setSliders}
                    name={"image"}
                  />
                </div>
              </Col>
              <Row>
                <Col lg={6} xs={12}>
                  <div className="form-group required">
                    <h5>
                      <FormattedMessage id={"title"} /> (
                      <FormattedMessage id="arabic-language" />)
                    </h5>
                    <input
                      type="title"
                      name="heading.ar"
                      className="form-control form-outline"
                      onChange={(e) => handleInputOnChange(e, index)}
                      value={slider?.heading?.ar}
                    />
                  </div>
                </Col>
                <Col lg={6} xs={12}>
                  <div className="form-group required">
                    <h5>
                      <FormattedMessage id={"title"} /> (
                      <FormattedMessage id="english-language" />)
                    </h5>
                    <input
                      type="title"
                      name="heading.en"
                      className="form-control form-outline"
                      onChange={(e) => handleInputOnChange(e, index)}
                      value={slider?.heading?.en}
                    />
                  </div>
                </Col>
                <Col lg={6} xs={12}>
                  <div className="form-group required">
                    <h5>
                      <FormattedMessage id={"boldTitle"} /> (
                      <FormattedMessage id="arabic-language" />)
                    </h5>
                    <input
                      type="text"
                      name="boldHeading.ar"
                      className="form-control form-outline"
                      onChange={(e) => handleInputOnChange(e, index)}
                      value={slider?.boldHeading?.ar}
                    />
                  </div>
                </Col>
                <Col lg={6} xs={12}>
                  <div className="form-group required">
                    <h5>
                      <FormattedMessage id={"boldTitle"} /> (
                      <FormattedMessage id="english-language" />)
                    </h5>
                    <input
                      type="text"
                      name="boldHeading.en"
                      className="form-control form-outline"
                      onChange={(e) => handleInputOnChange(e, index)}
                      value={slider?.boldHeading?.en}
                    />
                  </div>
                </Col>
                <Col lg={6} xs={12}>
                  <div className="form-group required">
                    <h5>
                      <FormattedMessage id={"description"} /> (
                      <FormattedMessage id="arabic-language" />)
                    </h5>
                    <textarea
                      autoComplete="true"
                      name={"description.ar"}
                      className="form-control form-outline"
                      onChange={(e) => handleInputOnChange(e, index)}
                      value={slider?.description?.ar}
                    />
                  </div>
                </Col>
                <Col lg={6} xs={12}>
                  <div className="form-group required">
                    <h5>
                      <FormattedMessage id={"description"} /> (
                      <FormattedMessage id="english-language" />)
                    </h5>
                    <textarea
                      autoComplete="true"
                      name={"description.en"}
                      className="form-control form-outline"
                      onChange={(e) => handleInputOnChange(e, index)}
                      value={slider?.description?.en}
                    />
                  </div>
                </Col>
                {/* country */}
                <Col lg={6} xs={12}>
                  <div className="form-group required">
                    <h5>
                      <FormattedMessage id={"country"} /> (
                      <FormattedMessage id="arabic-language" />)
                    </h5>

                    <select
                      name={"countryId"}
                      className="form-control form-outline"
                      onChange={(e) => handleInputOnChange(e, index)}
                      value={slider?.countryId || ""}
                    >
                      <option value="">Select an option</option>
                      {countries.map((country) => (
                        <option key={country.id} value={country.id}>
                          {country.name.ar}
                        </option>
                      ))}
                    </select>
                  </div>
                </Col>
              </Row>

              {/* <Row>
                                <Col lg={6} xs={12}>
                                    <div className="form-group required">
                                        <h5>
                                            <FormattedMessage
                                                id={
                                                    "imageTitle"
                                                }
                                            />{" "}
                                            (
                                            <FormattedMessage id="arabic-language" />
                                            )
                                        </h5>
                                        <input
                                            type="title"
                                            name={
                                                "imageTitle.ar"
                                            }
                                            className="form-control form-outline"
                                            onChange={(e) =>
                                                handleInputOnChange(
                                                    e,
                                                    index
                                                )
                                            }
                                            value={
                                                slider?.imageTitle
                                                    ?.ar
                                            }
                                        />
                                    </div>
                                </Col>
                                <Col lg={6} xs={12}>
                                    <div className="form-group required">
                                        <h5>
                                            <FormattedMessage
                                                id={
                                                    "imageTitle"
                                                }
                                            />{" "}
                                            (
                                            <FormattedMessage id="arabic-language" />
                                            )
                                        </h5>
                                        <input
                                            type="title"
                                            name={
                                                "imageTitle.en"
                                            }
                                            className="form-control form-outline"
                                            onChange={(e) =>
                                                handleInputOnChange(
                                                    e,
                                                    index
                                                )
                                            }
                                            value={
                                                slider?.imageTitle
                                                    ?.en
                                            }
                                        />
                                    </div>
                                </Col>
                            </Row> */}
              {/* <Row>
                        <Col lg={6}>
                          <div className="form-group">
                            <h5>
                              <FormattedMessage id={"title"} /> ({" "}
                              <FormattedMessage id={"arabic-language"} /> )
                            </h5>
                            <input
                              type="title"
                              name={"title.ar"}
                              className="form-control form-outline"
                              onChange={(e) => handleInputOnChange(e, index)}
                              value={slider?.title.ar}
                            />
                          </div>
                        </Col>
                        <Col lg={6}>
                          <div className="form-group">
                            <h5>
                              <FormattedMessage id={"title"} /> ({" "}
                              <FormattedMessage id={"english-language"} /> )
                            </h5>
                            <input
                              type="title"
                              name={"title.en"}
                              className="form-control form-outline"
                              onChange={(e) => handleInputOnChange(e, index)}
                              value={slider?.title.en}
                            />
                          </div>
                        </Col>
                      </Row>
                      <Row>
                        <Col lg={6}>
                          <div className="form-group">
                            <h5>
                              <FormattedMessage id={"description"} /> ({" "}
                              <FormattedMessage id={"arabic-language"} /> )
                            </h5>
                            <textarea
                              type="description"
                              name={"description.ar"}
                              className="form-control form-outline"
                              onChange={(e) => handleInputOnChange(e, index)}
                              value={slider?.description.ar}
                            />
                          </div>
                        </Col>
                        <Col lg={6}>
                          <div className="form-group">
                            <h5>
                              <FormattedMessage id={"description"} /> ({" "}
                              <FormattedMessage id={"english-language"} /> )
                            </h5>
                            <textarea
                              type="description"
                              name={"description.en"}
                              className="form-control form-outline"
                              onChange={(e) => handleInputOnChange(e, index)}
                              value={slider?.description.en}
                            />
                          </div>
                        </Col>
                      </Row> */}
            </Row>
          </Row>
        </Row>
      </div>
    </Row>
  );
};

export default SliderItem;
